// reducer.js - Редьюсер для хранения конфигурации UID
// SPRINT_10: Кэширование конфигурации UID в Redux

import {
  LOAD_UID_CONFIG,
  LOAD_UID_CONFIG_SUCCESS,
  LOAD_UID_CONFIG_FAILURE,
  INVALIDATE_UID_CONFIG,
} from './actions';

const initialState = {
  // Конфигурации по UID ID: { [uidId]: { stations, tags, components, alarmRules, trendConfigs, codeGroups, commandTemplates, loadedAt } }
  configs: {},
  // Состояния загрузки: { [uidId]: boolean }
  loading: {},
  // Ошибки: { [uidId]: string }
  errors: {},
};

/**
 * Редьюсер для управления состоянием конфигурации UID
 * @param {Object} state - Текущее состояние
 * @param {Object} action - Действие
 * @returns {Object} Новое состояние
 */
export const uidConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_UID_CONFIG:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.uidId]: true,
        },
        errors: {
          ...state.errors,
          [action.payload.uidId]: null,
        },
      };

    case LOAD_UID_CONFIG_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.uidId]: false,
        },
        configs: {
          ...state.configs,
          [action.payload.uidId]: {
            ...action.payload.config,
            loadedAt: Date.now(),
          },
        },
        errors: {
          ...state.errors,
          [action.payload.uidId]: null,
        },
      };

    case LOAD_UID_CONFIG_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.uidId]: false,
        },
        errors: {
          ...state.errors,
          [action.payload.uidId]: action.payload.error,
        },
      };

    case INVALIDATE_UID_CONFIG: {
      const newConfigs = { ...state.configs };
      delete newConfigs[action.payload.uidId];
      const newLoading = { ...state.loading };
      delete newLoading[action.payload.uidId];
      const newErrors = { ...state.errors };
      delete newErrors[action.payload.uidId];
      return {
        ...state,
        configs: newConfigs,
        loading: newLoading,
        errors: newErrors,
      };
    }

    default:
      return state;
  }
};

